import { useState } from 'react';

import { AddContactForm } from './components/AddContact/AddContactForm';
import {
  CurrentReferenceCreatePane,
  ReferencePaneProps,
} from 'features/References/types/referenceTypes';
import { Reference } from 'types';
import { ReferenceCreateLandingPage } from './components/LandingPage/ReferenceCreateLandingPage';
import {
  candidateFeedbackToasts,
  HiringRequestToast,
} from '../Connect/features/ConnectATSIntegration/enums';

export const ReferencePane: React.FC<ReferencePaneProps> = ({
  hiringRequestId,
  onCancel,
  setFeedbackModalToast,
  referenceId,
  roleTitle,
  candidate,
}) => {
  const [currentReferencePane, setCurrentReferencePane] =
    useState<CurrentReferenceCreatePane>('landingPage');
  const [newReferenceContact, setNewReferenceContact] = useState<Reference>(null);

  const handleNewReferenceContactClick = () => setCurrentReferencePane('addContact');
  const handleSetNewContact = (reference: Reference) => setNewReferenceContact(reference);

  const handleBackClick = (reference: Reference) => {
    setFeedbackModalToast({
      type: HiringRequestToast.SUCCESS,
      message: candidateFeedbackToasts.referenceContact,
    });
    setCurrentReferencePane('landingPage');
    setNewReferenceContact(reference);
  };

  return (
    <>
      {currentReferencePane === 'landingPage' && (
        <ReferenceCreateLandingPage
          candidate={candidate}
          newReferenceContact={newReferenceContact}
          onAddClick={handleNewReferenceContactClick}
          onCancel={onCancel}
          hiringRequestId={hiringRequestId}
          setFeedbackModalToast={setFeedbackModalToast}
          referenceId={referenceId}
          roleTitle={roleTitle}
        />
      )}
      {currentReferencePane === 'addContact' && (
        <AddContactForm
          candidateId={candidate.id}
          onBackClick={handleBackClick}
          onCancel={onCancel}
          handleSetNewContact={handleSetNewContact}
          candidateName={`${candidate.first_name} ${candidate.last_name}`}
        />
      )}
    </>
  );
};
